module.exports = __webpack_public_path__ + "static/media/girl-20.ec4da825.svg";